<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="red-plates">
  <header class="red-plates--header">
    <div class="red-plates--header__container">
      <h5 class="red-plates--header__title">
        {{ 'newRequestRedPlates' | i18next }}
      </h5>
      <div id="stepperHeader"></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestTypeEnum.redPlates"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</main>
